export class PatientAccountBase {
  public current_balance: number;
  public max_payment_allowed: number;
  public accept_balance_payments: boolean;
  public accept_invoice_payments: boolean;
}
